import React from 'react';

const TypographyList = () => {
  return (
    <div className="items">
      <div>
        <p className="editorial-large semibold mb-md">
          Typography (
          <a
            className="editorial-large semibold underline"
            href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=5201-2188"
          >
            Reference
          </a>
          )
        </p>
        <p className="caption mb-xl">
          Example usage: <code className="code-example">class="body-small semibold strikethrough"</code>
        </p>
      </div>
      <div className="section" style={{ alignItems: 'flex-start' }}>
        <div className="column section-wrap">
          <p className="editorial semibold" style={{ borderBottom: '1px solid var(--primary)' }}>
            Headings
          </p>
          {/* Display */}
          <p className="display">Display</p>
          {/* Heading-1-Proxima */}
          <h1 className="h1">Heading-1</h1>
          {/* Heading-2-Proxima */}
          <h2 className="h2">Heading-2</h2>
          {/* Heading-3-Proxima */}
          <h3 className="h3">Heading-3</h3>
          {/* Heading-4-Proxima */}
          <h4 className="h4">Heading-4</h4>
          {/* Heading-5-Proxima */}
          <h5 className="h5">Heading-5</h5>
          {/* Heading-6-Proxima */}
          <h6 className="h6">Heading-6</h6>
          {/* Heading-6-Proxima-Strikethrough */}
          <h6 className="h6 strikethrough">Heading-6-Strikethrough</h6>
          {/* Editorial-Heading-Large */}
          <p className="editorial-large">Editorial-Heading-Large</p>
          {/* Editorial-Heading-Medium */}
          <p className="editorial">Editorial-Heading-Medium</p>
        </div>
        <div className="column section-wrap">
          <p className="editorial semibold" style={{ borderBottom: '1px solid var(--primary)' }}>
            Body
          </p>
          {/* Body-Lg */}
          <p className="body-large">Body-Lg</p>
          {/* Body-Lg-Light */}
          <p className="body-large light">Body-Lg-Light</p>
          {/* Body (default) */}
          <p className="body">Body (default)</p>
          {/* Body-Strikethrough */}
          <p className="body strikethrough">Body-Strikethrough</p>
          {/* Body-Underline */}
          <p className="body underline">Body-Underline</p>
          {/* Body-Semibold */}
          <p className="body semibold">Body-Semibold</p>
          {/* Body-Semibold-Strikethrough */}
          <p className="body semibold strikethrough">Body-Semibold-Strikethrough</p>
          {/* Body-Semibold-Underline */}
          <p className="body semibold underline">Body-Semibold-Underline</p>
          {/* Body-Bold */}
          <p className="body bold">Body-Bold</p>
          {/* Body-Bold-Strikethrough */}
          <p className="body bold strikethrough">Body-Bold-Strikethrough</p>
          {/* Body-Bold-Underline */}
          <p className="body bold underline">Body-Bold-Underline</p>
          {/* Body-Sml */}
          <p className="body-small">Body-Sm</p>
          {/* Body-Sml-Strikethrough */}
          <p className="body-small strikethrough">Body-Sm-Strikethrough</p>
          {/* Body-Sml-Underline */}
          <p className="body-small underline">Body-Sm-Underline</p>
          {/* Body-Sml-Semibold */}
          <p className="body-small semibold">Body-Sm-Semibold</p>
          {/* Body-Sml-Semibold-Strikethrough */}
          <p className="body-small semibold strikethrough">Body-Sm-Semibold-Strikethrough</p>
          {/* Body-Sml-Semibold-Underline */}
          <p className="body-small semibold underline">Body-Sm-Semibold-Underline</p>
          {/* Body-Sml-Bold */}
          <p className="body-small bold">Body-Sm-Bold</p>
          {/* Body-Sml-Bold-Strikethrough */}
          <p className="body-small bold strikethrough">Body-Sm-Bold-Strikethrough</p>
          {/* Body-Sml-Bold-Underline */}
          <p className="body-small bold underline">Body-Sm-Bold-Underline</p>
          {/* Legal */}
          <p className="legal">Legal</p>
          {/* CTA-Large */}
          <p className="cta">CTA-Large (default)</p>
          {/* CTA-Medium */}
          <p className="cta-medium">CTA-Medium</p>
          {/* CTA-Small */}
          <p className="cta-small">CTA-Small</p>
          {/* Tag-Large */}
          <p className="tag-large">Tag-Large</p>
          {/* Tag-Medium */}
          <p className="tag">Tag-Medium (default)</p>
          {/* Tag-Small-Uppercase */}
          <p className="tag-small uppercase">Tag-Small</p>
          {/* Tag-Small-Lowercase */}
          <p className="tag-small semibold">Tag-Small-Semibold</p>
          {/* Banner */}
          <p className="banner">Banner</p>
        </div>
      </div>
    </div>
  );
};

export default TypographyList;
